<template>
    <div>
        <span class="center-horizontally">
        <p-button @click="refresh" type="default" size="sm" outline  :disabled="loading">
                <b-icon icon="arrow-clockwise"/><span>{{ $t('button.refresh') }}</span>
        </p-button> 
         <b-spinner v-if="loading" style="width: 1em; height: 1em; margin-left: 10px" label="Loading"></b-spinner>
        </span>

        <b-table
            :items="items"
            :fields="fields"
            :busy="loading"
            sticky-header="700px"
            :sort-by="'time'"
            :sort-desc="true"
            thead-class="d-none"
            tbody-class="tableClass"
            tbody-tr-class="trClass">

        <template #cell(time)="data">

            <span id="time" v-b-tooltip.hover :title=timeWithDateFormatter(data.item.time)>{{timeFormatter(data.item.time)}}</span>
        </template>
        </b-table>
    </div>
</template>

<script>
import sseDisplay from '@/store/displays/sseDisplay'
import moment from 'moment';

export default {
    props: {
        item: { default: null }
    },
    data: function() {
        return {
            loading: false
                    }
    },
    computed: {
        fields(){
            return [
                {key: 'time', label: this.$t('sse_displays.time'), sortable: true},
                {key: 'message', label: this.$t('sse_displays.message')}
            ]
        },
        items(){
            return this.$store.state.sseDisplay.sseDisplayLogs
        }
    },
    watch: {
        item(value){
                this.getSseLogs(value.deviceId);
        }
    },
    beforeCreate(){
        if(!this.$store.state.sseDisplay) {
            this.$store.registerModule("sseDisplay", sseDisplay)
        }   
    },
    mounted(){
        this.getSseLogs(this.item.deviceId)
    },
    methods: {
        getSseLogs(deviceId){
            this.loading = true;
            this.$store.dispatch('sseDisplay/getSseLogs', deviceId).then(() => {
                this.loading = false;
            })
        },
        timeFormatter(ts){
            var time = new moment(ts,'YYYY-MM-DD[T]HH:mm:ssZZ').format('HH:mm:ss');
            return time
        },
        timeWithDateFormatter(ts){
            var time = new moment(ts,'YYYY-MM-DD[T]HH:mm:ssZZ').format('YYYY-MM-DD HH:mm:ss');
            return time
        },
        refresh(){
            this.getSseLogs(this.item.deviceId);
        }
    }
}
</script>

<style lang="scss">
 .tableClass tr.trClass td {
    padding: 2px 5px;
    @media (max-width:1080px) {
        max-width: 20em;
    }
    @media (min-width:540px) {
        max-width: 15em;
    }

}
</style>